/// <amd-module name="Feed/PackageDetails/Util/Retention" />
import { FeedRetentionPolicy } from "Feed/Common/Contracts/Feed";

export class Retention {
    // Explicitly hard-coding for now. If we ever change the limit on the backend (or customer for accounts)
    // then we should plumb it through to the UI
    public static readonly VERSION_LIMIT = 5000;

    public static shouldDisplayRetention(retentionPolicy: FeedRetentionPolicy, versionCount: number): boolean {
        const retentionPolicyRetrieved = retentionPolicy !== undefined;

        const showMessage =
            this.isApproachingLimit(versionCount) &&
            retentionPolicyRetrieved &&
            (retentionPolicy === null || !retentionPolicy.countLimit);

        return showMessage;
    }

    public static isApproachingLimit(versionCount: number): boolean {
        return versionCount >= this.VERSION_LIMIT * 0.8;
    }

    public static isVeryCloseToLimit(versionCount: number): boolean {
        return versionCount >= this.VERSION_LIMIT * 0.95;
    }
}
